// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Header clock + date + backend status, on the site's clock: "15:21:06 EDT  Tue, Jul 28, 2026  • Live".

import React from 'react';
import { useNow } from '../../hooks/useNow';
import { useBackendStatus } from '../../hooks/useBackendStatus';
import { useSiteTime } from '../../hooks/useSiteTime';

export default function HeaderStatus() {
  const now = useNow();
  const status = useBackendStatus();
  // The only place the zone is named; that one statement covers every unlabelled time elsewhere.
  const { format, label } = useSiteTime();

  return (
    <div className="helios-clock">
      <span className="helios-clock-time" data-testid="header-time">
        {format(now, 'clockSeconds')}
        <span className="helios-clock-zone">{label}</span>
      </span>
      <span className="helios-clock-date" data-testid="header-date">
        {format(now, 'dateFull')}
      </span>
      <span className="helios-live" style={{ color: status.color }} data-testid="header-live">
        <span className="helios-live-dot" style={{ background: status.color }} />
        {status.label}
      </span>
    </div>
  );
}
